import { useFormik } from "formik";
import { useEffect, useState } from "react";
import * as Yup from "yup";
import * as commonServices from '../services/website.services';
import Swal from "sweetalert2";
import { ROLE_OPTIONS_FOR_WEBSITE, SWAL_SETTINGS } from "../../../utils/Constants";
import { capitalizeFirstLetter, handleServerValidations } from "../../../utils/commonfunction";
import { useSelector } from "react-redux";

const BostonPreLaunch = () => {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const formik = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      email: "",
      message: "",
      hereFor: ROLE_OPTIONS_FOR_WEBSITE[0].value,
    },
    validationSchema: Yup.object({
      firstName: Yup.string()
        .trim()
        .matches(/^[A-Za-z\s]+$/, "First name can only contain alphabets.")
        .min(3, "Name must be at least 3 characters.")
        .max(50, "Name cannot be more than 50 characters.")
        .required("Name is required."),

      email: Yup.string()
        .trim()
        .email("Invalid email")
        .matches(
          /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[A-Za-z]{2,}$/,
          "Please enter a valid email address."
        )
        .required("Email is required."),

      hereFor: Yup.string()
        .trim()
        .required("Please select on option.")
    }),
    onSubmit: (values, { resetForm }) => {
      const formData = new FormData();
      formData.append("hereFor", values.hereFor);
      formData.append("firstName", values.firstName);
      formData.append("lastName", values.lastName);
      formData.append("email", values.email);
      formData.append("message", values.message);
      commonServices.savePrelaunch(formData).then((response) => {
        if (response.success) {
          Swal.fire({
            icon: "success",
            text: response.message,
            ...SWAL_SETTINGS,
          });
          setTimeout(() => {
            resetForm();
          }, 1000);
        }
        else {
          Swal.fire({
            icon: "error",
            text: handleServerValidations(response),
            ...SWAL_SETTINGS,
          });
        }
      })
        .catch((error) => {
          console.log("error ====> ", error);
        });
    },
  });

  return (
    <main>
      <section className="banner-scetion-padding">
        <div className="container text-center">
          <p>babe, we’d love to have you</p>
          <h1 className="heading-1 main-heading-2">Boston Pre-Launch</h1>
          <h3 className="h3-headline text-color-primary">let us know you’re interested in joining our <strong>Boston Pre-Launch</strong></h3>
          <p><i>Please note: limited spots available, expected pre-launch timing is this October</i></p>
        </div>
      </section>
      <section className="Conditions-item section-padding">
        <div className="container">
          <div className="contact-info-block">
            <div className="row">
              <div className="col-md-12">
                <form className="contact-form" onSubmit={formik.handleSubmit}>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label subtitle-1">Here for...<span className="requirestar">*</span></label>
                        <div className="select-down-arrow">
                          <select
                            className="form-control"
                            name="hereFor"
                            value={formik.values.hereFor}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                          >
                            {ROLE_OPTIONS_FOR_WEBSITE && ROLE_OPTIONS_FOR_WEBSITE.map((item, index) => (
                              <option key={index} value={item.value}>
                                {capitalizeFirstLetter(item.label)}
                              </option>
                            ))}
                          </select>
                        </div>
                        {formik.touched.hereFor && formik.errors.hereFor && (
                          <div className="text-danger">{formik.errors.hereFor}</div>
                        )}
                      </div>

                    </div>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label subtitle-1">First Name<span className="requirestar">*</span></label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter first name"
                          name="firstName"
                          value={formik.values.firstName}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        />
                        {formik.touched.firstName && formik.errors.firstName && (
                          <div className="text-danger">{formik.errors.firstName}</div>
                        )}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label subtitle-1">Last Name</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter last name"
                          name="lastName"
                          value={formik.values.lastName}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        />
                        {formik.touched.lastName && formik.errors.lastName && (
                          <div className="text-danger">{formik.errors.lastName}</div>
                        )}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label subtitle-1">Email<span className="requirestar">*</span></label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter email"
                          name="email"
                          value={formik.values.email}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        />
                        {formik.touched.email && formik.errors.email && (
                          <div className="text-danger">{formik.errors.email}</div>
                        )}
                      </div>
                    </div>

                    <div className="col-md-12">

                      <div className="mb-3">
                        <label className="form-label subtitle-1">Tell us more (optional)</label>
                        <textarea
                          className="form-control"
                          placeholder="Feel free to toss in notes about how you found us, why you're interested, or how you see babe in your life"
                          name="message"
                          value={formik.values.message}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        />
                      </div>
                    </div>
                  </div>

                  <button type="submit" className="btn btn-purple">Submit</button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}

export default BostonPreLaunch;